import { FaIcon } from "./FaIcon";

export const EmbedFullPage: FaIcon.Icon = {
  icon: [300, 300, [], "", "M20 20 h260 v260 h-260 z"]
};
